import { useEffect, useState } from 'react'
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { CircularProgress, Divider } from '@mui/material';
import { TbSquareNumber1Filled, TbSquareNumber2Filled } from 'react-icons/tb';
import AddYourGuestModal from '../Modal/AddYourGuestModal';
import { useDispatch, useSelector } from 'react-redux';
import { add_guest, view_guest } from '../Redux/Action/GuestAction';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { get_event } from '../Redux/Action/EventAction';
import { useTranslation } from 'react-i18next';
import { FaRegFolderOpen } from "react-icons/fa";
import * as XLSX from 'xlsx';
import { useRef } from 'react';
import useTitle from '../Hooks/useTitle';
import PurchaseOfferModel from '../Modal/PurchaseOfferModel';
import { get_payment_plans } from '../Redux/Action/PaymentAction';
import NoPlanModel from '../Modal/NoPlanModel';

const AddGuest = () => {
    useTitle('Add Guest');
    const { t } = useTranslation('add_guest');
    const navigate = useNavigate();
    const [displayModal, setDisplayModal] = useState(true);
    const [openPurchaseModel, setOpenPurchaseModel] = useState(false);
    const [openNoPlanModel, setOpenNoPlanModel] = useState(false);
    const [activePlan, setActivePlan] = useState(null);

    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.Guest);
    const { viewevent } = useSelector((state) => state.Create);
    const { payment_plans } = useSelector((state) => state.Payment);
    const [jsonData, setJsonData] = useState(null);

    const [input, setinput] = useState({
        account_type: '',
        event_id: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
    })

    useEffect(() => {
        dispatch(get_event());
        dispatch(get_payment_plans());
    }, [dispatch])

    useEffect(() => {
        if (!payment_plans?.data?.length) return;

        const plans = payment_plans.data;
        const active = plans.find(plan => plan.is_active);
        setActivePlan(active || null);
        if (!active) {
            setOpenNoPlanModel(true);
        }
    }, [payment_plans]);

    useEffect(() => {

        if (!jsonData) return;

        const handleCSVSubmit = (guestsArray) => {
            if (!activePlan) {
                toast.error(t('no_plan_found'));
                return;
            }

            if (!activePlan.remaining_guests) {
                toast.error('Guest limit exceeded!');
                return setOpenPurchaseModel(true);
            } else if (guestsArray.length > activePlan.remaining_guests && !activePlan.is_unlimited) {
                return toast.error(t('limit_exceeded_csv_msg'));
            }

            const invalidGuests = guestsArray.filter((guest) => {
                return !guest.account_type || !guest.event_name || !guest.first_name || !guest.last_name || !guest.email_id;
            });

            if (invalidGuests.length > 0 || guestsArray.length <= 0) {
                // console.log("invalidGuests: ", invalidGuests);
                toast.error(t("error_msg"));
                return;
            }

            Promise.all(guestsArray.map((guest) => {
                return dispatch(add_guest(
                    guest.account_type === "demo" ? "0" : guest.account_type === "event" ? "1" : null,
                    viewevent?.data?.filter((v) => v.name === guest.event_name)?.[0]?.id,
                    guest.first_name,
                    guest.last_name,
                    guest.email_id,
                    String(guest.phone || '-')
                ));
            }))
                .then(() => {
                    toast.success(t("toast_submit"));
                    navigate("/GuestList");
                    dispatch(view_guest());
                })
                .catch((error) => {
                    if (error.response.data.message === 'Guest limit exceeded!') {
                        setOpenPurchaseModel(true);
                        toast.error(error.response.data.message || t("toast_error"))
                        return
                    }
                    toast.error(error.response.data.message || t("toast_error"));
                });
        };

        jsonData && handleCSVSubmit(jsonData);
    }, [jsonData, dispatch, navigate, t, viewevent?.data])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!input.account_type || !input.event_id || !input.first_name || !input.last_name || !input.email) {
            toast.error(t("error_msg"))
            return;
        }
        else {
            dispatch(add_guest(input.account_type, viewevent?.data?.filter((v) => v.name === input.event_id)?.[0]?.id, input.first_name, input.last_name, input.email, input.phone || '-'))
                .then(() => {
                    toast.success(t("toast_submit"))
                    navigate("/GuestList")
                    dispatch(view_guest());

                })
                .catch((error) => {
                    if (error.response.data.message === 'Guest limit exceeded!') {
                        setOpenPurchaseModel(true);
                        toast.error(error.response.data.message || t("toast_error"))
                        return
                    }
                    toast.error(error.response.data.message || t("toast_error"))
                })
        }
        setinput({
            account_type: '',
            event_id: '',
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
        });

    }

    const handlecancel = (e) => {
        e.preventDefault();
        setinput({
            account_type: '',
            event_id: '',
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
        });
    }
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleBrowseClick = () => {
        fileInputRef.current.click();
    };

    // Handle file selection (from browse button)
    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            if (file.type !== 'text/csv') return toast.error('Only CSV Files Allowed !!');

            setSelectedFile(file);
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = XLSX.read(data, { type: 'binary' });

                const jsonSheet = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
                setJsonData(jsonSheet);
            };

            reader.readAsBinaryString(file);
        };
    }

    // Handle drag over event (to allow dropping)
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    // Handle drop event (file dropped into the area)
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const file = e.dataTransfer.files[0];
        if (file) {
            if (file.type !== 'text/csv') return toast.error('Only CSV Files Allowed !!');

            setSelectedFile(file);
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = XLSX.read(data, { type: 'binary' });

                const jsonSheet = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
                setJsonData(jsonSheet);
            };

            reader.readAsBinaryString(file);
        }
    };

    const handleCSVDownload = () => {
        const csvUrl = "/data/example.csv"; 
        const link = document.createElement("a");
        link.href = csvUrl;
        link.setAttribute("download", "example.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handlePurchseConfirm = () => {
        navigate('/Rate');
    }

    return (
        <>
            <div className="grid gap-6  p-8 py-6  mt-[76px] sm:ml-[300px]">
                <div className=" items-center z-[1] ">
                    <span className='font-[600] text-[26px] '>{t("page_header")}</span>
                </div>
                {
                    loading ?
                        (
                            <div className="w-full h-[calc(100vh-290px)] flex justify-center items-center">
                                <CircularProgress size="3rem" />
                            </div>

                        ) :
                        (
                            <>
                                <form action="" method='POST' onSubmit={handleSubmit} className='bg-white py-6  flex flex-col  rounded-[20px]'>
                                    <div className="grid gap-8 ">
                                        <div className="div w-full grid grid-cols-1 gap-5 px-6 sm:grid-cols-1 md:grid-cols-3">
                                            <div className="flex flex-col gap-2 ">
                                                <span className='text-[14px] font-[500] text-[#131415] text-left'>{t("account_type_title")}*</span>

                                                <Select className='  text-[14px]'
                                                    value={input.account_type}
                                                    displayEmpty
                                                    onChange={(e) => setinput({
                                                        ...input, account_type: e.target.value
                                                    })}
                                                    renderValue={(selected) => {
                                                        if (!selected) {
                                                            return t("account_type_placeholder");
                                                        }
                                                        return selected === '0' ? 'Demo' : selected === '1' ? 'Event' : '';
                                                    }}
                                                    sx={{
                                                        border: 'none', borderRadius: 3, borderColor: '#c3cbd7', height: '44px', fontSize: 14,
                                                    }}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: {
                                                                marginTop: '7px',
                                                                borderRadius: '8px',

                                                            },
                                                        },
                                                    }}
                                                >

                                                    <MenuItem value='0' sx={{ fontSize: 14, }}>Demo </MenuItem>
                                                    <MenuItem value='1' sx={{ fontSize: 14, }}> Event</MenuItem>

                                                </Select>
                                            </div>
                                            <div className="flex flex-col gap-2 ">
                                                <span className='text-[14px] font-[500] text-[#131415] text-left'>{t("select_event")}*</span>

                                                <Select className='  text-[14px]'
                                                    value={input.event_id}

                                                    displayEmpty
                                                    onChange={(e) => setinput({
                                                        ...input, event_id: e.target.value
                                                    })}
                                                    renderValue={(selected) => selected || t("select_event_placeholder")}
                                                    sx={{
                                                        border: 'none', borderRadius: 3, borderColor: '#c3cbd7', height: '44px', fontSize: 14,

                                                    }}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: {
                                                                marginTop: '7px',
                                                                borderRadius: '8px',

                                                            },
                                                        },
                                                    }}
                                                >
                                                    {
                                                        viewevent.data && viewevent.data.map((obj) => (
                                                            <MenuItem key={obj.id} value={obj.name} sx={{ fontSize: 14, }}>
                                                                {obj.name}
                                                            </MenuItem>

                                                        ))
                                                    }


                                                </Select>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t("first_name")}*</span>
                                                <input type='text' placeholder={t("first_name_placeholder")} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                                    name='first_name'
                                                    value={input.first_name}
                                                    onChange={(e) => setinput({
                                                        ...input, [e.target.name]: e.target.value
                                                    })}
                                                ></input>
                                            </div>
                                        </div>
                                        <div className="div w-full grid grid-cols-1 gap-5 px-6 sm:grid-cols-1 md:grid-cols-3">
                                            <div className="flex flex-col gap-2">
                                                <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t("last_name")}*</span>
                                                <input type='text' placeholder={t("last_name_placeholder")} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                                    name='last_name'
                                                    value={input.last_name}
                                                    onChange={(e) => setinput({
                                                        ...input, [e.target.name]: e.target.value
                                                    })}
                                                ></input>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t("email")}*</span>
                                                <input type='email' placeholder={t("email_placeholder")} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                                    name='email'
                                                    value={input.email}
                                                    onChange={(e) => setinput({
                                                        ...input, [e.target.name]: e.target.value
                                                    })}
                                                ></input>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t("phone")}</span>
                                                <input type='text' placeholder={t("phone_placeholder")} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                                    name='phone'
                                                    value={input.phone}
                                                    onChange={(e) => setinput({
                                                        ...input, [e.target.name]: e.target.value
                                                    })}
                                                ></input>
                                            </div>
                                        </div>
                                        <Divider sx={{ marginTop: 4, marginBottom: -1 }} />
                                        <div className='px-6 flex justify-end gap-3 '>
                                            <button className='text-[#3686FF]  rounded-lg py-[12px] text-[14px] w-full max-w-40' style={{ border: '1px solid #3686FF' }} onClick={handlecancel}>{t("btn_cancel")}</button>
                                            <button type='submit' className='bg-[#3686FF] text-white rounded-lg  py-[12px] text-[14px] w-full max-w-40' >{t("page_header")}</button>
                                        </div>
                                    </div>
                                </form>

                                <div className=" bg-white p-6  flex flex-col gap-5 rounded-[20px] ">

                                    <div className="bg-[#F6F6F6] p-3 rounded-[9px] flex gap-4 border border-dashed border-black">
                                        <div className='flex flex-col justify-center items-center w-full gap-5 '>
                                            <div className="file-upload-container w-full">
                                                {/* File Upload Box with Drag-and-Drop */}
                                                <div
                                                    className="file-upload-box bg-[#F6F6F6] p-6 rounded-lg "
                                                    onDragOver={handleDragOver}
                                                    onDrop={handleDrop}
                                                >
                                                    <div className="flex flex-col justify-center items-center gap-5">
                                                        <div className="bg-white text-[#3686FF] p-5 rounded-full shadow-sm shadow-[#adc1ff]">
                                                            <FaRegFolderOpen size={45} />
                                                        </div>
                                                        <div className="font-bold">{t('upload_csv_file')}</div>

                                                        {/* Browse Button */}
                                                        <button
                                                            className="flex gap-3 justify-center items-center bg-[#3686FF] h-[40px] w-[150px] rounded-lg"
                                                            onClick={handleBrowseClick}
                                                        >
                                                            <FaRegFolderOpen color="white" />
                                                            <span className="text-white">{t('browseFile')}</span>
                                                        </button>

                                                        {/* Display the name of the selected or dropped file */}
                                                        {selectedFile && (
                                                            <div className="text-[#3686FF] font-semibold mt-2">
                                                                Selected File: {selectedFile.name}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Hidden file input */}
                                                <input
                                                    ref={fileInputRef}
                                                    type="file"
                                                    className="hidden"
                                                    accept=".csv"
                                                    onChange={handleFileChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className=" bg-white p-6  flex flex-col gap-5 rounded-[20px]">
                                    <span className='text-[20px] font-[600] text-[#131415] '>{t('welcome_message')} 🎉</span>
                                    <div className="bg-[#F6F6F6] p-3 rounded-[9px] grid gap-4 ">
                                        <p className='font-[600] text-[#131415] text-[18px] ' > {t('how_to_proceed')}</p>
                                        <div className='flex gap-2 text-[15px] items-start'>
                                            <span><TbSquareNumber1Filled fill='#3686FF' size={25} /></span>
                                            <p className='text-[#535861]'><span className='font-[600] text-[#131415]'> {t('personalize_message')}: : </span> {t('personalize_message_desc')}</p>
                                        </div>
                                        <div className='flex gap-2 text-[15px] items-start'>
                                            <span><TbSquareNumber2Filled fill='#3686FF' size={25} /></span>
                                            <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>  {t('add_details')} :</span>{t('add_details_desc')}</p>
                                        </div>
                                        <p className='text-[#535861] text-[15px] '> {t('explore_platform')}</p>
                                        <p>{t('example_csv_1')}<button className='text-[#3686FF]' onClick={handleCSVDownload}>{t('example_csv_2')}</button></p>
                                    </div>
                                </div>
                            </>
                        )
                }
            </div >
            <AddYourGuestModal
                displayModal={displayModal}
                setDisplayModal={setDisplayModal}
            />

            <PurchaseOfferModel
                open={openPurchaseModel}
                onClose={() => setOpenPurchaseModel(false)}
                onConfirm={handlePurchseConfirm}
            />

            <NoPlanModel 
                open={openNoPlanModel}
                onClose={() => setOpenNoPlanModel(false)}
            />

        </>
    )
}

export default AddGuest